import React from "react";

import { ProgressBarWidgetIconProps } from "../../../../types/widgets";

export const ProgressBarWidget5 = (props: ProgressBarWidgetIconProps) => (
  <svg
    width="310"
    height="16"
    viewBox="0 0 310 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M28 8.00002L304 8"
      stroke={props.inactivebarcolor || "#F1F1F1"}
      strokeWidth="12"
      strokeLinecap="round"
    />
    <path
      d="M6 8H150"
      stroke={props.activebarcolor || "#E0E0E0"}
      strokeWidth="12"
      strokeLinecap="round"
    />
    <circle
      cx="57"
      cy="8"
      r="7"
      fill={props.breakpointactive || "#E0E0E0"}
      stroke="white"
      strokeWidth="2"
    />
    <circle
      cx="120"
      cy="8"
      r="7"
      fill={props.breakpointactive || "#E0E0E0"}
      stroke="white"
      strokeWidth="2"
    />
    <circle
      cx="186"
      cy="8"
      r="7"
      fill={props.breakpointinactive || "#F1F1F1"}
      stroke="white"
      strokeWidth="2"
    />
    <circle
      cx="252"
      cy="8"
      r="7"
      fill={props.breakpointinactive || "#F1F1F1"}
      stroke="white"
      strokeWidth="2"
    />
  </svg>
);
